

export const aracTonajOptionsShort = [
    {
        aracTypeId:4,
        aracTypeName:"Tır",
        tonajOptions: [
            {
                value: 9,
                text: "Hafif Yük"
            },
            {
                value: 18,
                text: "Normal Yük"
            },
            {
                value: 27,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:3,
        aracTypeName:"Kırkayak",
        tonajOptions: [
            {
                value: 7,
                text: "Hafif Yük"
            },
            {
                value: 14,
                text: "Normal Yük"
            },
            {
                value: 21,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:5,
        aracTypeName:"10 Teker Kamyon",
        tonajOptions: [
            {
                value: 5,
                text: "Hafif Yük"
            },
            {
                value: 11,
                text: "Normal Yük"
            },
            {
                value: 16,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:6,
        aracTypeName:"6 Teker Kamyon",
        tonajOptions: [
            {
                value: 2,
                text: "Hafif Yük"
            },
            {
                value: 3,
                text: "Normal Yük"
            },
            {
                value: 5.5,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:7,
        aracTypeName:"Kamyon Römork",
        tonajOptions: [
            {
                value: 9,
                text: "Hafif Yük"
            },
            {
                value: 18,
                text: "Normal Yük"
            },
            {
                value: 27,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:1,
        aracTypeName:"Kamyonet",
        tonajOptions: [
            {
                value: 1.5,
                text: "Hafif Yük"
            },
            {
                value: 2.5,
                text: "Normal Yük"
            },
            {
                value: 4,
                text: "Ağır Yük"
            }
        ]
    },
    {
        aracTypeId:2,
        aracTypeName:"Panelvan",
        tonajOptions: [
            {
                value: 0.5,
                text: "Hafif Yük"
            },
            {
                value: 1,
                text: "Normal Yük"
            },
            {
                value: 1.5,
                text: "Ağır Yük"
            }
        ]
    }
] 


const aracTonajOptions = [
    {
        aracTypeId:4,
        aracTypeName:"Tır",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            },
            {
                value: 5,
                text: "5 Ton",
            },
            {
                value: 6,
                text: "6 Ton",
            },
            {
                value: 7,
                text: "7 Ton",
            },
            {
                value: 8,
                text: "8 Ton",
            },
            {
                value: 9,
                text: "9 Ton",
            },
            {
                value: 10,
                text: "10 Ton",
            },
            {
                value: 11,
                text: "11 Ton",
            },
            {
                value: 12,
                text: "12 Ton",
            },
            {
                value: 13,
                text: "13 Ton",
            },
            {
                value: 14,
                text: "14 Ton",
            },
            {
                value: 15,
                text: "15 Ton",
            },
            {
                value: 16,
                text: "16 Ton",
            },
            {
                value: 17,
                text: "17 Ton",
            },
            {
                value: 18,
                text: "18 Ton",
            },
            {
                value: 19,
                text: "19 Ton",
            },
            {
                value: 20,
                text: "20 Ton",
            },
            {
                value: 21,
                text: "21 Ton",
            },
            {
                value: 22,
                text: "22 Ton",
            },
            {
                value: 23,
                text: "23 Ton",
            },
            {
                value: 24,
                text: "24 Ton",
            },
            {
                value: 25,
                text: "25 Ton",
            },
            {
                value: 26,
                text: "26 Ton",
            },
            {
                value: 27,
                text: "27 Ton",
            }
        ]
    },
    {
        aracTypeId:3,
        aracTypeName:"Kırkayak",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            },
            {
                value: 5,
                text: "5 Ton",
            },
            {
                value: 6,
                text: "6 Ton",
            },
            {
                value: 7,
                text: "7 Ton",
            },
            {
                value: 8,
                text: "8 Ton",
            },
            {
                value: 9,
                text: "9 Ton",
            },
            {
                value: 10,
                text: "10 Ton",
            },
            {
                value: 11,
                text: "11 Ton",
            },
            {
                value: 12,
                text: "12 Ton",
            },
            {
                value: 13,
                text: "13 Ton",
            },
            {
                value: 14,
                text: "14 Ton",
            },
            {
                value: 15,
                text: "15 Ton",
            },
            {
                value: 16,
                text: "16 Ton",
            },
            {
                value: 17,
                text: "17 Ton",
            },
            {
                value: 18,
                text: "18 Ton",
            },
            {
                value: 19,
                text: "19 Ton",
            },
            {
                value: 20,
                text: "20 Ton",
            },
            {
                value: 21,
                text: "21 Ton",
            }
        ]
    },
    {
        aracTypeId:5,
        aracTypeName:"10 Teker Kamyon",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            },
            {
                value: 5,
                text: "5 Ton",
            },
            {
                value: 6,
                text: "6 Ton",
            },
            {
                value: 7,
                text: "7 Ton",
            },
            {
                value: 8,
                text: "8 Ton",
            },
            {
                value: 9,
                text: "9 Ton",
            },
            {
                value: 10,
                text: "10 Ton",
            },
            {
                value: 11,
                text: "11 Ton",
            },
            {
                value: 12,
                text: "12 Ton",
            },
            {
                value: 13,
                text: "13 Ton",
            },
            {
                value: 14,
                text: "14 Ton",
            },
            {
                value: 15,
                text: "15 Ton",
            },
            {
                value: 16,
                text: "16 Ton",
            },
        ]
    },
    {
        aracTypeId:6,
        aracTypeName:"6 Teker Kamyon",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            },
            {
                value: 5,
                text: "5 Ton",
            },
            {
                value: 5.5,
                text: "5,5 Ton",
            },
        ]
    },
    {
        aracTypeId:7,
        aracTypeName:"Kamyon Römork",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            },
            {
                value: 5,
                text: "5 Ton",
            },
            {
                value: 6,
                text: "6 Ton",
            },
            {
                value: 7,
                text: "7 Ton",
            },
            {
                value: 8,
                text: "8 Ton",
            },
            {
                value: 9,
                text: "9 Ton",
            },
            {
                value: 10,
                text: "10 Ton",
            },
            {
                value: 11,
                text: "11 Ton",
            },
            {
                value: 12,
                text: "12 Ton",
            },
            {
                value: 13,
                text: "13 Ton",
            },
            {
                value: 14,
                text: "14 Ton",
            },
            {
                value: 15,
                text: "15 Ton",
            },
            {
                value: 16,
                text: "16 Ton",
            },
            {
                value: 17,
                text: "17 Ton",
            },
            {
                value: 18,
                text: "18 Ton",
            },
            {
                value: 19,
                text: "19 Ton",
            },
            {
                value: 20,
                text: "20 Ton",
            },
            {
                value: 21,
                text: "21 Ton",
            },
            {
                value: 22,
                text: "22 Ton",
            },
            {
                value: 23,
                text: "23 Ton",
            },
            {
                value: 24,
                text: "24 Ton",
            },
            {
                value: 25,
                text: "25 Ton",
            },
            {
                value: 26,
                text: "26 Ton",
            },
            {
                value: 27,
                text: "27 Ton",
            }
        ]
    },
    {
        aracTypeId:1,
        aracTypeName:"Kamyonet",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 0.5,
                text: "0,5 Ton",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 1.5,
                text: "1,5 Ton",
            },
            {
                value: 2,
                text: "2 Ton",
            },
            {
                value: 2.5,
                text: "2,5 Ton",
            },
            {
                value: 3,
                text: "3 Ton",
            },
            {
                value: 3.5,
                text: "3,5 Ton",
            },
            {
                value: 4,
                text: "4 Ton",
            }
        ]
    },
    {
        aracTypeId:2,
        aracTypeName:"Panelvan",
        tonajOptions:[
            {
                value: 0,
                text: "Boş",
            },
            {
                value: 0.5,
                text: "0,5 Ton",
            },
            {
                value: 1,
                text: "1 Ton",
            },
            {
                value: 1.5,
                text: "1,5 Ton",
            },
        ]
    },
]
export default aracTonajOptions
